import api from "@/services/api";

const endpoint = () => `/visual-medica`;

const visualMedicaService = {};

// Devuelve { redirectUrl } con la URL (de un solo uso) del visor de imágenes
// para el paciente. La genera el backend con las credenciales del visor.
visualMedicaService.getRedirectUrl = function (patientId) {
  return api
    .post(`${endpoint()}/redirect`, { patientId })
    .then((res) => res.data);
};

export default visualMedicaService;
